import { AppService } from './app.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/forkJoin'
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable()
export class TechnologyResolver implements Resolve<any> {
    constructor(private appService: AppService, private router: Router) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        let language = route.params['language'];
        if (!environment.allowedLanguages[language]) {
            this.router.navigate(['/not-found']);
            return null;
        }
        return Observable.forkJoin(
            this.appService.getTechnology(language),
        ).map(results => {
            if (results[0]) {
                let technology = results[0].json();
                return (technology[0] ? technology[0] : {});
            }
            return null;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/providers/technology-resolver.service.ts